import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit, AfterViewInit {

  private _modalRef:any;

  constructor(private _rootNode: ElementRef) { }

  ngOnInit(){
  }

  ngAfterViewInit() {
    this._modalRef = $(this._rootNode.nativeElement).find('#modalSubscription');
    this._modalRef.modal('show');
  }

}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts